function parseNumber(value) {
    if (typeof value === 'number') {
        return value;
    }
    return Number.parseFloat(value.replace(/[$,]/g, ''));
}
export { parseNumber };
//# sourceMappingURL=parseNumber.js.map